import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import ReactTooltip from 'react-tooltip';


import { urlFor, client } from '../../client';
import './Skills.scss';

const Skills = () => {
  const [experiences, setExperiences] = useState([]);
  const [skills, setSkills] = useState([]);

  useEffect(() => {
    const query = '*[_type == "experiences"]';
    const skillsQuery = '*[_type == "skills"]';

    client.fetch(query).then((data) => {
      setExperiences(data);
    });

    client.fetch(skillsQuery).then((data) => {
      setSkills(data);
    });
  }, []);

  return (
    <div id='skills'>
      <h2 className="head-text">Skills & Experiences</h2>

      <div className="app__skills-container">
        <motion.div className="app__skills-list">
          {skills.map((skill) => (
            <motion.div
              whileInView={{ opacity: [0, 1] }}
              transition={{ duration: 0.5 }}
              className="app__skills-item app__flex"
              key={skill.name}
            >
              <div
                className="app__flex"
                style={{ backgroundColor: skill.bgColor }}
              >
                <img src={urlFor(skill.icon)} alt={skill.name} />
              </div>
              <p className="p-text">{skill.name}</p>
            </motion.div>
          ))}
        </motion.div>
        <div className="app__skills-exp">
          {/* {experiences.map((experience) => ( */}
          <motion.div
            className="app__skills-exp-item"
            key="{experience.year}"
          >


            <div className="app__skills-exp-year">
              <p className="bold-text">2022 - Present</p>
            </div>
            <motion.div className="app__skills-exp-works">

              <motion.div
                whileInView={{ opacity: [0, 1] }}
                transition={{ duration: 0.5 }}
                className="app__skills-exp-work"
                data-tip

              >
                <h4 className="bold-text">Google Developer Student Club SRM</h4>
                <p className="p-text">Technical Team Member</p>
              </motion.div>
              <ReactTooltip
                id="work.name"
                effect="solid"
                arrowColor="#fff"
                className="skills-tooltip"
              >
                Helped our club to create website for the club in React.js
              </ReactTooltip>





            </motion.div>
          </motion.div>

          <motion.div
            className="app__skills-exp-item"
            key="{experience.year}"
          >


            <div className="app__skills-exp-year">
              <p className="bold-text">2021 - 2022  </p>
            </div>
            <motion.div className="app__skills-exp-works">

              <motion.div
                whileInView={{ opacity: [0, 1] }}
                transition={{ duration: 0.5 }}
                className="app__skills-exp-work"
                data-tip

              >
                <h4 className="bold-text">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;CodeChef SRM</h4>
                <p className="p-text">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Member of Competitive Programming Domain</p>
              </motion.div>
              <ReactTooltip
                id="work.name"
                effect="solid"
                arrowColor="#fff"
                className="skills-tooltip"
              >
                Helped students by explaining different topics of Data Structure and Algorithm
              </ReactTooltip>





            </motion.div>
          </motion.div>


          {/* ))} */}
        </div>
      </div>
    </div>
  );
};

export default Skills